import { filterType, filterData } from "../../../../../helpers/filterHelper";
import { showToastError, showMessageApi } from "../../../../Main/actions";
import trace from "../../../../../helpers/trace";


import {
  getAllPools,
  getPoolById,
  deletePoolById,
  updatePoolById,
  createPool,
  examsList,
} from "../../../../../services/poolsApi";

export const loading = (isLoading) => ({
  type: "LOADING_MANTENEDOR_BATERIA",
  isLoading,
});

export const setListaBateriasFiltradas = (lista) => ({
  type: "SET_LISTA_BATERIAS_FILTRADAS",
  lista,
});

export const setListaBaterias = (data) => ({
  type: "SET_LISTA_BATERIAS",
  data,
});

export const setFiltrosBaterias = (filtros) => ({
  type: "SET_FILTROS_BATERIAS",
  filtros,
});

export const setBatery = (batery) => ({
  type: "SET_BATERY",
  batery,
});

export const openCloseModalEditarBateria = (isOpen, batery, isNew) => ({
  type: "OPEN_CLOSE_MODAL_EDITAR_BATERIA",
  isOpen,
  batery,
  isNew,
});

export const openCloseModalEliminarBateria = (isOpen, batery) => ({
  type: "OPEN_CLOSE_MODAL_ELIMINAR_BATERIA",
  isOpen,
  batery,
});

export const openCloseModalDesactivarBateria = (isOpen, batery) => ({
  type: "OPEN_CLOSE_MODAL_DESACTIVAR_BATERIA",
  isOpen,
  batery,
});

export const setExamsList = (list) => ({
  type: "SET_EXAMS_LIST",
  list,
});

export const getExamsList = () => async (dispatch) => {
  try {
    const _baterias = await examsList();
    const _resultBaterias = await _baterias.json();
    // const examenes = _resultBaterias && _resultBaterias.Exams ? _resultBaterias.Exams.map((e) => e.ExamTypeId === 1 ? e : null).filter((f) => f) : [];
    // const psicologicos = _resultBaterias && _resultBaterias.Exams ? _resultBaterias.Exams.map((e) => e.ExamTypeId === 2 ? e : null).filter((f) => f) : [];
    let listaBaterias = _resultBaterias.filter((b) => b.ExamTypeId === 1 && b.Status === 1);
    dispatch(setExamsList(listaBaterias));
  } catch (e) {
    trace.error("getExamsList", e);
  }
};

export const doGetBaterias = (filtros, reload = false) => async (dispatch) => {
  dispatch(loading(true));
  try {
    let message;

    const request = await getAllPools();
    if (request.status === 200) {
      const result = await request.json();
      dispatch(setListaBaterias(result));
      if (filtros) {
        const newData = filterData(result, filtros);
        dispatch(setListaBateriasFiltradas(newData));
      }
    } else {
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
    }
  } catch (e) {
    trace.error("doGetBaterias", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};

export const doGetFiltrosBaterias = () => async (dispatch) => {
  dispatch(loading(true));
  try {
    const filtros = [
      {
        column: "Status",
        name: "Activo",
        type: "bool",
        values: [
          { value: 1, text: "Si" },
          { value: 0, text: "No" },
        ],
      },
    ];
    dispatch(setFiltrosBaterias(filtros));
  } catch (e) {
    trace.error("doGetBaterias", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};

export const doAddBateria = (newRow) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const _data = {
      Description: newRow.Description,
      Enabled: !!newRow.Status,
      ExamsId: newRow.listExams,
    };
    let message;
    const request = await createPool(_data);
    if (request.status === 200) {
      message = `Se ha agregado la batería ${newRow.Description}.`;
      dispatch(openCloseModalEditarBateria(false, {}, false));
      dispatch(doGetBaterias(null, true));
      dispatch(showMessageApi(message, request));
    } else {
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
    }
  } catch (e) {
    trace.error("doAddBateria", e);
    dispatch(showToastError());
  }

  dispatch(loading(false));
};


export const doUpdateBateria = (editedRow) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const _data = {
      Id: editedRow.Id,
      RelationIdExamsDelete: editedRow.ExamsDetails.filter((i) => !editedRow.listExams.some((ii) => (i.Id === ii))).map((e) => e.RelationId),
      Description: editedRow.Description,
      Enabled: editedRow.Status,
      ExamsId: editedRow.listExams.filter((i) => !editedRow.ExamsDetails.some((ii) => (i === ii.Id))),
    };
    let message;

    const request = await updatePoolById(_data);
    if (request.status === 200) {
      message = `Se ha editado la batería ${editedRow.Description}.`;
      dispatch(openCloseModalEditarBateria(false, {}, false));
      dispatch(openCloseModalDesactivarBateria(false, {}, false));
      dispatch(doGetBaterias(null, true));
      dispatch(showMessageApi(message, request));
    } else {
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
    }
  } catch (e) {
    trace.error("doUpdateBateria", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};

export const doGetBateria = (id) => async (dispatch) => {
  dispatch(loading(true));
  try {
    let message;
    const request = await getPoolById(id);
    if (request.status === 200) {
      const result = await request.json();
      result.listExams = result.ExamsDetails.map((e) => e.Id);
      dispatch(openCloseModalEditarBateria(true, result, false));
    } else {
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
    }
  } catch (e) {
    trace.error("doGetBateria", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};

export const doDeleteBateria = (bateria) => async (dispatch) => {
  dispatch(loading(true));
  try {
    let message;
    const request = await deletePoolById(bateria.Id);
    if (request.status === 200) {
      message = `Se ha eliminado la batería ${bateria.Description}.`;
      dispatch(doGetBaterias(null, true));
      dispatch(showMessageApi(message, request));
    } else {
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
    }
    dispatch(openCloseModalEliminarBateria(false, {}));
  } catch (e) {
    trace.error("doDeleteBateria", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};
